import { renderToString } from "react-dom/server";

const html_render = (data) => {
    const { webContent, figcaptionDiff, tdthUpdate } = data
    if (!webContent) {
        return null;
    }
    const body = document.createElement("div");
    body.innerHTML = webContent;
    try {
        Object.keys(figcaptionDiff)?.forEach((key) => {
            console.log(figcaptionDiff[key]);
        })
        Object.keys(tdthUpdate)?.forEach((key) => {
            console.log()
            body.querySelectorAll('[data-uniquecode="'+key+'"]').forEach(e => {
                e.innerHTML = `<span class='bpl-diff-modify'>${tdthUpdate[key]}</span> ${e.innerHTML}`
                if(tdthUpdate[key] === ''){
                    e.style.backgroundColor = "rgb(173, 228, 234)";
                }
            })
        })
    } catch(e) {}

    let body2 = body.innerHTML.replaceAll(/(\[:[^\]]+:\])/g, '<a onClick=\'event.stopPropagation()\' class=\'tblref\' data-tblref=\'$1\'>$1</a>')
    return body2;
}

export default html_render;